import type Shepherd from 'shepherd.js'

export type ShepherdTour = InstanceType<typeof Shepherd.Tour>

/** `cancel()` on a completed tour re-fires 'cancel' and would end the app tour via exitTour('skipped'). */
export function cancelIfActive(tour: ShepherdTour) {
	if (tour.isActive()) {
		try {
			void tour.cancel()
		} catch {
			/* ignore */
		}
	}
}
